'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _SaveOutlined = _interopRequireDefault(require('./lib/icons/SaveOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _SaveOutlined;
exports.default = _default;
module.exports = _default;